export default "__VITE_ASSET__3ouv91QQ__"